/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClientDetailsViewModel,
  ErrorResult,
  IAPPARTYTYPE,
  NotFoundErrorResult,
  Result,
  ResultOfClientDetailsResponseViewModel,
  ResultOfClientDetailsViewModel,
  ResultOfIEnumerableOfBasePartyViewModel,
  ResultOfPopiaStatusViewModel,
  ResultOfSchemeEmployerModel,
  UpdatePopiaStatusModel,
  ValidationErrorResult,
} from '../models';
import {
    ClientDetailsViewModelFromJSON,
    ClientDetailsViewModelToJSON,
    ErrorResultFromJSON,
    ErrorResultToJSON,
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfClientDetailsResponseViewModelFromJSON,
    ResultOfClientDetailsResponseViewModelToJSON,
    ResultOfClientDetailsViewModelFromJSON,
    ResultOfClientDetailsViewModelToJSON,
    ResultOfIEnumerableOfBasePartyViewModelFromJSON,
    ResultOfIEnumerableOfBasePartyViewModelToJSON,
    ResultOfPopiaStatusViewModelFromJSON,
    ResultOfPopiaStatusViewModelToJSON,
    ResultOfSchemeEmployerModelFromJSON,
    ResultOfSchemeEmployerModelToJSON,
    UpdatePopiaStatusModelFromJSON,
    UpdatePopiaStatusModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface ClientDetailsFetchRequest {
    proposalId?: number | null;
    partyId?: number | null;
}

export interface ClientDetailsGetPopiaStatusRequest {
    partyId?: number;
    proposalId?: number | null;
}

export interface ClientDetailsGetSearchPartyRequest {
    searchTerm?: string | null;
    partyTypes?: Array<IAPPARTYTYPE> | null;
    excludeTrustsWithOrganisationsAsBeneficiaries?: boolean;
}

export interface ClientDetailsSubmitRequest {
    clientDetails: ClientDetailsViewModel;
    duplicateCheck?: boolean;
}

export interface ClientDetailsUpdateRequest {
    clientDetails: ClientDetailsViewModel;
}

export interface ClientDetailsUpdatePopiaStatusRequest {
    partyId: number;
    updateModel: UpdatePopiaStatusModel;
}

/**
 * 
 */
export class ClientDetailsApi extends runtime.BaseAPI {

    /**
     * Get a client\'s details
     */
    async clientDetailsFetchRaw(requestParameters: ClientDetailsFetchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfClientDetailsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.partyId !== undefined) {
            queryParameters['partyId'] = requestParameters.partyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/client-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfClientDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get a client\'s details
     */
    async clientDetailsFetch(requestParameters: ClientDetailsFetchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfClientDetailsViewModel> {
        const response = await this.clientDetailsFetchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all scheme employers
     */
    async clientDetailsGetEmployerSchemesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfSchemeEmployerModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/client-details/scheme-employers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfSchemeEmployerModelFromJSON(jsonValue));
    }

    /**
     * Get all scheme employers
     */
    async clientDetailsGetEmployerSchemes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfSchemeEmployerModel> {
        const response = await this.clientDetailsGetEmployerSchemesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a client\'s popia status
     */
    async clientDetailsGetPopiaStatusRaw(requestParameters: ClientDetailsGetPopiaStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfPopiaStatusViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.partyId !== undefined) {
            queryParameters['partyId'] = requestParameters.partyId;
        }

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/client-details/popia-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfPopiaStatusViewModelFromJSON(jsonValue));
    }

    /**
     * Get a client\'s popia status
     */
    async clientDetailsGetPopiaStatus(requestParameters: ClientDetailsGetPopiaStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfPopiaStatusViewModel> {
        const response = await this.clientDetailsGetPopiaStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search all parties
     */
    async clientDetailsGetSearchPartyRaw(requestParameters: ClientDetailsGetSearchPartyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIEnumerableOfBasePartyViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.searchTerm !== undefined) {
            queryParameters['searchTerm'] = requestParameters.searchTerm;
        }

        if (requestParameters.partyTypes) {
            queryParameters['partyTypes'] = requestParameters.partyTypes;
        }

        if (requestParameters.excludeTrustsWithOrganisationsAsBeneficiaries !== undefined) {
            queryParameters['excludeTrustsWithOrganisationsAsBeneficiaries'] = requestParameters.excludeTrustsWithOrganisationsAsBeneficiaries;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/client-details/search-parties`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIEnumerableOfBasePartyViewModelFromJSON(jsonValue));
    }

    /**
     * Search all parties
     */
    async clientDetailsGetSearchParty(requestParameters: ClientDetailsGetSearchPartyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIEnumerableOfBasePartyViewModel> {
        const response = await this.clientDetailsGetSearchPartyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new proposal
     */
    async clientDetailsSubmitRaw(requestParameters: ClientDetailsSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfClientDetailsResponseViewModel>> {
        if (requestParameters.clientDetails === null || requestParameters.clientDetails === undefined) {
            throw new runtime.RequiredError('clientDetails','Required parameter requestParameters.clientDetails was null or undefined when calling clientDetailsSubmit.');
        }

        const queryParameters: any = {};

        if (requestParameters.duplicateCheck !== undefined) {
            queryParameters['duplicateCheck'] = requestParameters.duplicateCheck;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/client-details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientDetailsViewModelToJSON(requestParameters.clientDetails),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfClientDetailsResponseViewModelFromJSON(jsonValue));
    }

    /**
     * Create a new proposal
     */
    async clientDetailsSubmit(requestParameters: ClientDetailsSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfClientDetailsResponseViewModel> {
        const response = await this.clientDetailsSubmitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update client\'s details
     */
    async clientDetailsUpdateRaw(requestParameters: ClientDetailsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.clientDetails === null || requestParameters.clientDetails === undefined) {
            throw new runtime.RequiredError('clientDetails','Required parameter requestParameters.clientDetails was null or undefined when calling clientDetailsUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/client-details`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ClientDetailsViewModelToJSON(requestParameters.clientDetails),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Update client\'s details
     */
    async clientDetailsUpdate(requestParameters: ClientDetailsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.clientDetailsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a Person popia status.
     */
    async clientDetailsUpdatePopiaStatusRaw(requestParameters: ClientDetailsUpdatePopiaStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.partyId === null || requestParameters.partyId === undefined) {
            throw new runtime.RequiredError('partyId','Required parameter requestParameters.partyId was null or undefined when calling clientDetailsUpdatePopiaStatus.');
        }

        if (requestParameters.updateModel === null || requestParameters.updateModel === undefined) {
            throw new runtime.RequiredError('updateModel','Required parameter requestParameters.updateModel was null or undefined when calling clientDetailsUpdatePopiaStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/client-details/popia-status/{partyId}`.replace(`{${"partyId"}}`, encodeURIComponent(String(requestParameters.partyId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePopiaStatusModelToJSON(requestParameters.updateModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Update a Person popia status.
     */
    async clientDetailsUpdatePopiaStatus(requestParameters: ClientDetailsUpdatePopiaStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.clientDetailsUpdatePopiaStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
